export default __webpack_public_path__ + "static/media/Poppins-Black.dbe23113.woff2";